var swiper = new Swiper(".gallery-thumbs", {
  spaceBetween: 12,
  slidesPerView: 5,
  watchSlidesProgress: true,
  slideToClickedSlide: true
});
var swiper2 = new Swiper(".gallery-slider", {
  spaceBetween: 0,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});



$(document).on('click', '.content-title-tab', function () {
  $(this).addClass('active');
  $(this).siblings().removeClass('active');
  let data = '.content-title-mobile[data-title="' + $(this).attr('data-title') + '"]';
  $(data).siblings().removeClass('active');
  $(data).addClass('active');
})
$(document).on('click', '.content-title-mobile', function () {
  $(this).siblings().removeClass('active');
  $(this).toggleClass('active');
})  

$(document).on('click', '.show-more-swatch ', function () {
  $(this).toggleClass('show-less');
  $(this).closest('.swatch-container').children().children('.list-item-swatch-hide').toggleClass('hidden');
})

$(document).on('click', '.selected_value_option_button', function () {
  $(this).toggleClass('active');
  $('.overlay-sticky-cart').toggleClass('hidden');
  $('body').toggleClass('overflow-hidden');
  $(this).closest('.sticky-cart-container').children('.list-option-size').toggleClass('hidden');
  
})

$(document).on('click', '.list-option-size-item', function () {
  $('.overlay-sticky-cart').addClass('hidden');
  $('body').removeClass('overflow-hidden')
})

$(document).on('click', '.overlay-sticky-cart', function () {
  $(this).addClass('hidden');
  $('body').removeClass('overflow-hidden');
})


$(window).scroll(function() {
  let product_tab_postion = $('.product-tabs-wraps').position().top;
  if ( window.scrollY < product_tab_postion ) {
    $('.sticky-cart-container').addClass('hidden');
  } else {
    $('.sticky-cart-container').removeClass('hidden');
  }
});


$(window).ready(function() {
  if ($('.zoom').length) {
    $('.zoom').zoom({ magnify: 1.8 });
  }
  if ($(window).width() < 750) {
    $('.zoom').trigger('zoom.destroy');
  }
  $(window).on('resize', function() {
    if ($(window).width() < 750) {
      $('.zoom').trigger('zoom.destroy');
    } else {
      if ($('.zoom').length) {
        $('.zoom').zoom({ magnify: 1.8 });
      }
    }
  });
});